/**
 * Utilitários para texto rico (Prime Editor / Quill).
 */

const EMPTY_QUILL_BLOCK = /^<p>(\s*<br\s*\/?>\s*)?<\/p>$/i;

/**
 * True se o HTML for vazio ou só placeholder do editor (ex.: &lt;p&gt;&lt;br&gt;&lt;/p&gt;).
 */
export function isRichTextEmpty(html) {
    if (html === null || String(html).trim() === '') return true;
    const s = String(html).trim();
    if (EMPTY_QUILL_BLOCK.test(s)) return true;
    const text = s
        .replace(/<[^>]+>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    return text.length === 0;
}

/**
 * Texto plano para prévia em listas (remove tags).
 */
export function richTextToPlainPreview(html, maxLen = 100) {
    if (isRichTextEmpty(html)) return '';
    const text = String(html)
        .replace(/<[^>]+>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    if (maxLen > 0 && text.length > maxLen) return `${text.slice(0, maxLen)}…`;
    return text;
}
